import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import ConnectedHeader from '../connectedComponents/ConnectedHeader.js';
import ConnectedMenu from '../connectedComponents/ConnectedMenu.js';
import { apis } from '../api';
import throttle from 'lodash.throttle';
import { message, Breadcrumb, Icon, Form, Select } from 'antd';
import { Button, Input, Table, Modal } from 'antd';

import RoleAdd from './RoleAdd.js';
import { breadBack, changeListWidth, setScrollTop } from '../utils';
import { calcTableHeight, showMoreSearch, breadItem } from '../utils';
import { loadingOptionsHtml, formatDate } from '../utils';
import TableEmpty from '../components/TableEmpty.js';
const { Option } = Select;
const { confirm } = Modal;

class RoleManager extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listWidth: 'calc(87% - 8px)',
      roleList: [],
      addModalVisible: false,
      userList: [],
      menuList: [],
      roleInfo: {},
      detailType: '',
      selectedRowKeys: [],
      searchLoading: true,
      tableHeight: 0,
      moreFilter: true,
      showMoreFilter: false,
    };

    this.throttledRoleList = throttle(newState => {
      setScrollTop();
      this.getRoleInfoList(newState);
    }, 1000);

    this.formResize = throttle(newState => {
      //页面大小改变，更新table高度
      const newHeight = calcTableHeight(165) || 0;
      const showMore = showMoreSearch();
      this.setState({ showMoreFilter: showMore, tableHeight: newHeight });
    }, 1000);
  }

  static propTypes = {
    history: PropTypes.object,
    form: PropTypes.object,
    productList: PropTypes.array,
  };

  componentDidMount() {
    this.throttledRoleList();
    this.getUserList();
    this.getMenus();
    let _this = this;
    window.addEventListener('resize', function() {
      _this.formResize();
    });
    this.formResize();
  }

  getMenus = () => {
    apis.getMenus().then(res => {
      if (res.code === '0') {
        const menuList = res.data;
        let len = 0;
        menuList.forEach(item => {
          len++;
          if (item.childMenus) {
            item.childMenus.forEach(child => {
              len++;
              if (child.childMenus) child.childMenus.forEach(ch => len++);
            });
          }
        });

        this.setState({ menuList: res.data, menuLen: len });
      } else if (res.code === '1009') this.props.history.push('/login');
    });
  };

  getRoleInfoList = newState => {
    const updatedState = Object.assign({}, this.state, newState);
    this.setState(updatedState);
    const post = {
      roleName: updatedState.roleName,
      roleProduct: updatedState.roleProduct,
      status: updatedState.status,
      sortBy: updatedState.sortBy,
      sort: updatedState.sort,
    };
    apis.roleInfoRecord(post).then(res => {
      this.setState({ searchLoading: false });
      if (res.code === '0') this.setState({ roleList: res.data });
      else if (res.code === '1009') this.props.history.push('/login');
      else this.setState({ roleList: [] });
    });
  };

  getUserList = () => {
    apis.boxUserRecord().then(res => {
      if (res.code === '0') this.setState({ userList: res.data });
      else if (res.code === '1009') this.props.history.push('/login');
      else this.setState({ userList: [] });
    });
  };

  getProductNames = list => {
    const names = [];
    list.map(item => names.push(item.productName));
    return names.join(', ');
  };

  getColumns = () => {
    const columns = [];
    columns.push(
      { title: '角色ID', dataIndex: 'id', key: 'id', width: '10%' },
      {
        title: '角色名称',
        dataIndex: 'roleName',
        key: 'roleName',
        width: '15%',
      },
      {
        title: '所属应用',
        dataIndex: 'productInfoList',
        key: 'productInfoList',
        width: '20%',
        render: list => <>{this.getProductNames(list)}</>,
      },
      {
        title: '状态',
        dataIndex: 'status',
        key: 'status',
        width: '15%',
        render: value => <>{value === '1' ? '启用' : '关闭'}</>,
      },
      {
        title: '操作时间',
        dataIndex: 'updateTime',
        key: 'update_time',
        width: '20%',
        sorter: true,
        sortDirections: ['ascend', 'descend'],
        render: value => <>{formatDate(value)}</>,
      },
      {
        title: '操作',
        dataIndex: '',
        key: 'operation',
        align: 'center',
        width: '20%',
        render: list => (
          <>
            <Button
              type="link"
              className="btn-viewdetail"
              onClick={this.showAddModal.bind(this, list, 'update')}
            >
              <Icon type="edit" theme="filled" />
              修改
            </Button>
            <Button
              type="link"
              className="btn-detail"
              onClick={this.showAddModal.bind(this, list, 'detail')}
            >
              <Icon type="eye" theme="filled" />
              详情
            </Button>
          </>
        ),
      }
    );

    return columns;
  };

  showDeleteConfirm = () => {
    const _this = this;
    const { selectedRowKeys } = this.state;
    confirm({
      title: '删除',
      content: '已选中1条数据，确定删除所选数据吗？',
      okText: '删除',
      okType: 'danger',
      cancelText: '取消',
      onOk() {
        apis.deleteRoleInfo(selectedRowKeys.join(',')).then(res => {
          if (res.code === '0') {
            message.success('删除成功');
            _this.throttledRoleList();
          } else if (res.code === '1009') _this.props.history.push('/login');
        });
      },
    });
  };

  showAddModal = (info, type) => {
    this.setState({ addModalVisible: true, roleInfo: info, detailType: type });
  };

  hideAddModal = changed => {
    const _this = this;
    setTimeout(function() {
      _this.setState({ addModalVisible: false });
    }, 1);

    if (changed) this.throttledRoleList();
  };

  handleSearch = e => {
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (!err) {
        const newState = {
          roleName: values.roleName,
          roleProduct: values.application,
          status: values.status,
          searchLoading: true,
        };
        this.throttledRoleList(newState);
      }
    });
  };

  //点击重置按钮
  handleReset = () => {
    this.props.form.resetFields();
  };
  setBackEvent = () => {
    // this.setSearchEvent('ns-066');
  };

  render() {
    const { getFieldDecorator, tableHeight } = this.props.form;
    const { roleList, moreFilter, showMoreFilter } = this.state;
    const { productList } = this.props;
    const columns = this.getColumns();

    const rowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        this.setState({ selectedRowKeys });
      },
      type: 'radio',
    };

    const loadingOptions = loadingOptionsHtml(this.state.searchLoading);

    return (
      <div className="form-bg">
        <ConnectedMenu toggleCollapsed={changeListWidth.bind(this, this)} />
        <div className="theme-content">
          <ConnectedHeader
            toggleCollapsed={changeListWidth.bind(this, this)}
            login={false}
            home={true}
          />
          <div className="theme-box">
            <div className="bread-crumb">
              <Breadcrumb>{breadItem(['系统管理', '角色管理'])}</Breadcrumb>
              {breadBack(this)}
            </div>
            <div
              className="box theme-RoleManager"
              style={{ width: this.state.listWidth }}
            >
              <div className="left">
                <Form
                  className={`ant-advanced-search-form${
                    !moreFilter && showMoreFilter ? ' notOverflow' : ''
                  }`}
                  onSubmit={this.handleSearch}
                  layout="inline"
                >
                  <div className="searchBox">
                    <div className="searchBoxContent">
                      <Form.Item label="角色名称" colon={false}>
                        {getFieldDecorator('roleName', {})(
                          <Input
                            allowClear={true}
                            placeholder="请输入角色名称"
                            style={{ width: 160 }}
                          />
                        )}
                      </Form.Item>
                      <Form.Item label="所属应用" colon={false}>
                        {getFieldDecorator('application', {})(
                          <Select
                            placeholder="选择所属应用"
                            allowClear={true}
                            style={{ width: 160 }}
                          >
                            {(productList || []).map(item => (
                              <Option key={item.productId}>
                                {item.productName}
                              </Option>
                            ))}
                          </Select>
                        )}
                      </Form.Item>
                      <Form.Item label="状态" colon={false}>
                        {getFieldDecorator('status', {})(
                          <Select
                            placeholder="选择状态"
                            allowClear={true}
                            style={{ width: 160 }}
                          >
                            <Option value="1">启用</Option>
                            <Option value="0">关闭</Option>
                          </Select>
                        )}
                      </Form.Item>
                    </div>
                  </div>
                  <div className="searchOptBox">
                    <Form.Item>
                      <Button
                        type="primary"
                        htmlType="submit"
                        className="btn-search"
                        disabled={this.state.searchLoading}
                      >
                        {this.state.loadingIconShow ? (
                          <Icon type="sync" spin />
                        ) : (
                          <Icon type="search" />
                        )}
                        搜索
                      </Button>
                      <Button
                        icon="redo"
                        style={{ marginLeft: 8 }}
                        className="btn-reset"
                        onClick={this.handleReset}
                        disabled={this.state.searchLoading}
                      >
                        重置
                      </Button>
                      <Button
                        className="btn-m-plus"
                        onClick={this.showAddModal}
                      >
                        <Icon type="plus" />
                        新增
                      </Button>
                      <Button
                        className="btn-m-delete"
                        disabled={this.state.selectedRowKeys.length === 0}
                        onClick={this.showDeleteConfirm}
                      >
                        <Icon type="delete" />
                        删除
                      </Button>
                    </Form.Item>
                    {showMoreFilter && (
                      <Button
                        type="link"
                        className="moreFilter"
                        onClick={() => {
                          this.setState({ moreFilter: !moreFilter });
                        }}
                        icon={moreFilter ? 'down' : 'up'}
                      >
                        {moreFilter ? '展开' : '收起'}
                      </Button>
                    )}
                  </div>
                </Form>
                <div className="history-list">
                  <Table
                    loading={loadingOptions}
                    rowSelection={rowSelection}
                    columns={columns}
                    dataSource={roleList}
                    rowKey={record => record.id}
                    key={record => record.id}
                    className="list-item"
                    scroll={{ x: 1200, y: tableHeight }}
                    locale={{ emptyText: <TableEmpty /> }}
                    pagination={{
                      size: 'small',
                      pageSize: 20,
                      total: roleList.length,
                      showTotal: () => `共${roleList.length}条`,
                    }}
                    onChange={(pagination, filters, sorter) => {
                      const orderType = { descend: 'DESC', ascend: 'ASC' };
                      const sortType = orderType[sorter.order];
                      const orderField = sorter.columnKey || '';
                      const newState = {
                        page: 1,
                        sortBy: orderField,
                        sort: sortType,
                        searchLoading: true,
                      };
                      this.throttledRoleList(newState);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <RoleAdd
          visible={this.state.addModalVisible}
          productList={this.props.productList || []}
          userList={this.state.userList}
          menuList={this.state.menuList}
          menuLen={this.state.menuLen || 0}
          roleInfo={this.state.roleInfo}
          detailType={this.state.detailType}
          onCancel={this.hideAddModal}
        />
      </div>
    );
  }
}

export default withRouter(Form.create()(RoleManager));
